export default __webpack_public_path__ + "static/media/gear-cog-wheel.9dc9ebd4.svg";